// reactstrap components
import { Container, Row } from "reactstrap";
import { useParams } from "react-router-dom";
// graphql
import { useQuery } from "@apollo/client";
import GetUser from "../../../queries/GetUser";
// core components
import Header from "../../../components/Headers/Header.js";
import UserDetails from "../../../components/UserDetails.js";

const User = () => {
  const params = useParams();
  const { loading, error, data } = useQuery(GetUser, {
    variables: { userId: params.userId },
  });

  if (loading) return null;
  if (error) {
    console.log("error:");
    console.log(error);
    return <p>Something Went Wrong...</p>;
  }

  const { user } = data;

  console.log("user:", user);

  return (
    <>
      <Header
        title={`User: ${user?.user_name}`}
        description={
          <>
            <div className="d-flex align-items-center mr-4">
              <i className="ni ni-badge text-white" />
              <span className="font-weight-bold mx-1">Role:</span>
              <span className="text-capitalize">{user?.role}</span>
            </div>
            {user?.survey_language && (
              <div className="d-flex align-items-center mr-4">
                <i className="ni ni-world-2 text-white" />
                <span className="font-weight-bold mx-1">Language:</span>
                <span className="text-capitalize">{user?.survey_language}</span>
              </div>
            )}
            {user?.trial_type && (
              <div className="d-flex align-items-center mr-4">
                <i className="ni ni-calendar-grid-58 text-white" />
                <span className="font-weight-bold mx-1">Trial:</span>
                <span className="text-capitalize">{user?.trial_type}</span>
              </div>
            )}
          </>
        }
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <UserDetails data={data} />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default User;
